export class FormCancelamentoModel {
  public mensagemSuporte: string;
  public flagCancelarAssinatura: boolean;
  public dataProximoPagamento: Date;
  public assinaturaCancelada: boolean;
  public motivoCancelamento: string;
}
